import { KeyboardCommandKeyRounded } from '@mui/icons-material';
import { HotKeyBox } from '../HotKeyBox';
import { ReactNode } from 'react';
import { getModKey } from '@modules/commandPalette/utils';
import { Box, Stack } from '@mui/material';

interface CmdHotKeyIconProps {
  isDisabled?: boolean;
  backgroundColor?: string;
  plusHotKeyNode: ReactNode;
}

export const CmdHotKeyIcon = ({
  isDisabled,
  backgroundColor,
  plusHotKeyNode,
}: CmdHotKeyIconProps) => {
  const getHotKeyBgColor = () => {
    if (backgroundColor) {
      return backgroundColor;
    }
    return isDisabled ? 'misc.hotKey.disabled' : undefined;
  };

  const getHotKeyDisplay = () => {
    return (
      <Stack direction="row" alignItems="center">
        {getModKey() === '⌘' ? (
          <KeyboardCommandKeyRounded
            sx={{
              fontSize: '1.1rem',
            }}
          />
        ) : (
          <Box>{getModKey()}</Box>
        )}
        <Box>+</Box>
        {plusHotKeyNode}
      </Stack>
    );
  };

  return (
    <HotKeyBox
      hotkeyDisplay={getHotKeyDisplay()}
      backgroundColor={getHotKeyBgColor()}
    />
  );
};
